import { render, staticRenderFns } from "./DownloadDocument.vue?vue&type=template&id=302130fa&scoped=true&"
import script from "./DownloadDocument.vue?vue&type=script&lang=js&"
export * from "./DownloadDocument.vue?vue&type=script&lang=js&"
import style0 from "./DownloadDocument.vue?vue&type=style&index=0&id=302130fa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302130fa",
  null
  
)

export default component.exports